import { useEffect } from 'react';

export const useUpToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};
